<script setup lang="ts">
import Header from "@/components/organisms/common/Header.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import PointCouponList from "@/components/organisms/mypage/PointCouponList.vue";
import PointCard from "@/components/organisms/mypage/PointCard.vue";
import { useRouter } from "vue-router";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { giftService } from "@/app/services/GiftService";
import { ref, onBeforeMount } from "vue";
import { Gift } from "@/types/Gift";
import { authStore } from "@/store/auth";

const { back } = useRouter();
const loader = useLoader();
const errorModal = useErrorModal();
const giftList = ref<Gift[]>([]);
const user = authStore.user!;

onBeforeMount(async () => {
  loader.show();
  try {
    await fetchPointGifts();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
});

const fetchPointGifts = async () => {
  const { results } = await giftService.fetchPointGifts();
  giftList.value = results;
};

const onClickBack = () => {
  back();
};
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      ポイント交換
    </Header>
    <PointCard :user="user" class="m-3" />
    <PointCouponList :giftList="giftList" class="m-3" />
  </div>
</template>
